module.exports = __webpack_public_path__ + "img/success-checkout.2cc6fc73.svg";